<div mat-dialog-title>Create Location</div>

<mat-dialog-content class="fx-col fx-gap-20">

  <div class="fx-row full-width fx-gap-10">
    <mat-form-field class="fx-flex-1">
      <mat-label>Location Name</mat-label>
      <input matInput [formControl]="form.controls.name" placeholder="e.g. Cape Town V&A" />
      <mat-error>Location name is required</mat-error>
    </mat-form-field>

    <mat-form-field class="fx-flex-1">
      <mat-label>Location Code</mat-label>
      <input matInput [formControl]="form.controls.code" placeholder="e.g. CPT-V1" />
      <button mat-icon-button matSuffix type="button"
              matTooltip="Auto-generate code from the location name"
              aria-label="Generate code from name"
              (click)="generateCode()">
        <mat-icon>auto_fix_normal</mat-icon>
      </button>
      <mat-error>Location code is required</mat-error>
    </mat-form-field>
  </div>

  <mat-form-field class="full-width">
    <mat-label>Address</mat-label>
    <input
      matInput
      matGoogleMapsAutocomplete
      [formControl]="form.controls.address"
      placeholder="Start typing an address..."
      (onAutocompleteSelected)="onAutocompleteSelected($event)"
      (onLocationSelected)="onLocationSelected($event)"
    />
    <mat-error>Address is required</mat-error>
  </mat-form-field>

  <div class="heading-bold">Images <span style="color: var(--mat-sys-on-surface-variant); font-size: 0.85em; font-weight: normal;">(optional — can be added later in Landlord Settings)</span></div>

  <div class="fx-row full-width fx-gap-10">
    <div class="fx-col fx-flex-1 fx-gap-10">
      <span>Tile Image</span>
      <div class="fx-row fx-v-center fx-gap-10">
        <button mat-stroked-button type="button" (click)="tileFileInput.click()">
          <mat-icon>upload</mat-icon> Choose File
        </button>
        @if (tileImageFile) {
          <span>{{ tileImageFile.name }}</span>
          <button mat-icon-button type="button" aria-label="Remove tile image" (click)="clearTileImage()">
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <span style="color: var(--mat-sys-on-surface-variant);">No file chosen</span>
        }
      </div>
      <input #tileFileInput type="file" accept="image/*" hidden (change)="onTileImageSelected($event)" />
    </div>

    <div class="fx-col fx-flex-1 fx-gap-10">
      <span>Banner Image</span>
      <div class="fx-row fx-v-center fx-gap-10">
        <button mat-stroked-button type="button" (click)="bannerFileInput.click()">
          <mat-icon>upload</mat-icon> Choose File
        </button>
        @if (bannerImageFile) {
          <span>{{ bannerImageFile.name }}</span>
          <button mat-icon-button type="button" aria-label="Remove banner image" (click)="clearBannerImage()">
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <span style="color: var(--mat-sys-on-surface-variant);">No file chosen</span>
        }
      </div>
      <input #bannerFileInput type="file" accept="image/*" hidden (change)="onBannerImageSelected($event)" />
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loader.loading$ | async">Cancel</button>
  <button mat-flat-button class="button-primary" (click)="onSubmit()" [disabled]="loader.loading$ | async">
    Create Location
  </button>
</mat-dialog-actions>
